/***********************************************************
 * Api function/route wrappers around the React Health API
 ***********************************************************
 *
 * @see https://portal.reacthealth.com/api/documentation
 *
 */

export const getPatientDevices = {
    /**
     * @param {number} patient_id
     * @returns {Promise}
     */
    request(patient_id) {
        return axios.get(this.route({patient_id}))
    },
    route: ({patient_id}) =>
        '/api/patients/{patient}/devices'
            .replace('{patient}', patient_id)
}

export const getPatientDevicesConnectionHistories = {
    /**
     * @param {number} patient_id
     * @param {number} history_id
     * @returns {Promise}
     */
    request(patient_id, history_id) {
        return axios.get(this.route({patient_id, history_id}))
    },
    route: ({patient_id, history_id}) =>
        '/api/patients/{patient}/devices/{history}/connection_history'
            .replace('{patient}', patient_id)
            .replace('{history}', history_id)
}
